// // import { IconCategory, IconMinus, IconPlaylistAdd, IconPlus, IconTrash } from '@tabler/icons-react';
// // import { FormikProps } from 'formik';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { useNavigate } from 'react-router-dom';
// // import { ATMButton } from 'src/components/atoms/ATMButton/ATMButton';
// // import ATMSelect from 'src/components/atoms/FormElements/ATMSelect/ATMSelect';
// // import { useFetchData } from 'src/hooks/useFetchData';
// // import { useGetCustomersQuery } from 'src/modules/Customer/service/CustomerServices';
// // import { useGetOutletsQuery } from 'src/modules/Outlet/service/OutletServices';
// // import { AppDispatch, RootState } from 'src/store';
// // import { CURRENCY } from 'src/utils/constants';
// // import { showToast } from 'src/utils/showToaster';
// // import { useGetDraftByIdMutation } from '../service/POSServices';
// // import {
// //   setIsOpenAddDialog,
// //   setIsOpenCustomerDialog,
// //   setIsOpenDraftListDialog,
// //   setPreviewNewCustomerId,
// //   setIsOpenTreatmentDialog
// // } from '../slice/CartSlice';
// // import DraftList from './DraftList';
// // import PaymentFormWrapper from './PaymentFormWrapper';
// // import AddNotes from './AddNotes';
// // import { useCallback, useEffect, useRef, useState } from 'react';
// // import { useSearchParams } from 'react-router-dom';
// // import AsyncSelect from 'react-select/async';
// // import { BASE_URL } from '../../../utils/constants/index';
// // type AmountSummaryCardProps = {
// //   items: any[];
// //   customer: any;
// // };
// // interface Customer {
// //   _id: string;
// //   bookingCustomerId: string;
// //   customerName: string;
// //   email: string;
// //   phone: string;
// //   isActive: boolean;
// //   isDeleted: boolean;
// // }

// // // Define the structure of each option
// // interface SelectOption {
// //   label: string;
// //   value: string;
// //   data: Customer;
// // }
// // export const calculatedAmounts = (items: any) => {
// //   let taxes: {
// //     taxType: string;
// //     taxAmount: number;
// //     taxPercent: number;
// //   }[] = [];
// //   let totalAmount = 0;

// //   items?.forEach((item: any) => {
// //     const matchedIndex = taxes?.findIndex(
// //       (el: any) => el?.taxType === item?.taxType,
// //     );
// //     if (matchedIndex > -1) {
// //       taxes[matchedIndex].taxAmount +=
// //         (item?.quantity * item?.sellingPrice * item?.taxPercent || 0) / 100;
// //     } else {
// //       taxes?.push({
// //         taxType: item?.taxType,
// //         taxPercent: item?.taxPercent,
// //         taxAmount:
// //           (item?.quantity * item?.sellingPrice * item?.taxPercent || 0) / 100,
// //       });
// //     }

// //     totalAmount +=
// //       Number(item?.sellingPrice) *
// //       Number(item?.quantity) *
// //       ((100 + (Number(item?.taxPercent) || 0)) / 100);
// //   });

// //   return {
// //     taxes,
// //     totalAmount: totalAmount?.toFixed(2),
// //   };
// // };

// // const AmountSummaryCard = ({ items, customer }: AmountSummaryCardProps) => {
// //   const dispatch = useDispatch<AppDispatch>();
// //   return (
// //     <div className="flex flex-col gap-2 space-y-1">
// //       <div>
// //         <div className="">
// //           {calculatedAmounts(items)?.taxes?.map((tax: any, index) => (
// //             <div key={index} className="flex gap-2 p-4 py-1">
// //               <div className="flex-1 text-xs truncate text-slate-500">
// //                 {tax?.taxType && tax?.taxPercent ? (
// //                   <div>
// //                     {' '}
// //                     {tax?.taxType} @ {tax?.taxPercent}%
// //                   </div>
// //                 ) : null}
// //               </div>
// //               {tax?.taxAmount ? (
// //                 <div className="min-w-[60px] text-sm  text-slate-600 text-right">
// //                   {CURRENCY} {tax?.taxAmount.toFixed(2)}
// //                 </div>
// //               ) : null}
// //             </div>
// //           ))}
// //         </div>

// //         <div className="flex gap-2 px-4 py-1 bg-yellow-100">
// //           <div className="flex-1 text-base font-medium ">Sub Total</div>
// //           <div className="min-w-[60px] text-base font-medium text-slate-800 text-right">
// //             {CURRENCY} {calculatedAmounts(items)?.totalAmount}
// //           </div>
// //         </div>
// //       </div>
// //       <div className="px-4 ">
// //         <ATMButton
// //           onClick={() => dispatch(setIsOpenAddDialog(true))}
// //           children="Pay Now"
// //           disabled={!customer}
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // type Props = {
// //   cartItems: any[];
// //   onRemove: (itemId: string) => void;
// //   onQuantityChange: (itemId: string, type: 'INCREMENT' | 'DECREMENT') => void;
// //   formikProps: FormikProps<any>;
// //   isDisabled: boolean;
// // };
// // const useDebounce = (callback: Function, delay: number) => {
// //   const timerRef = useRef<NodeJS.Timeout | null>(null);

// //   return useCallback(
// //     (...args: any[]) => {
// //       if (timerRef.current) clearTimeout(timerRef.current);
// //       timerRef.current = setTimeout(() => {
// //         callback(...args);
// //       }, delay);
// //     },
// //     [callback, delay],
// //   );
// // };
// // const CartSummarySection = ({
// //   cartItems,
// //   onRemove,
// //   onQuantityChange,
// //   formikProps,
// //   isDisabled
// // }: Props) => {


// //   // console.log('-----cartItems',cartItems)
// //   const [searchParams, setSearchParams] = useSearchParams();
// //   const bookingCustomer = searchParams.get('customer');
// //   const [loading, setLoading] = useState(false);
// //   const [selectedCustomer, setSelectedCustomer] = useState<SelectOption | null>(
// //     null,
// //   );

// //   const { values, setFieldValue } = formikProps;
// //   const [isOpenAddNotesDialog, setIsOpenAddNotesDialog] = useState(false);
// //   const { userData, outlet, accessToken } = useSelector(
// //     (state: RootState) => state.auth,
// //   );
// //   // console.log('token', accessToken);

// //   const { isOpenDraftListDialog, isOpenCustomerDialog } = useSelector(
// //     (state: RootState) => state.cart,
// //   );
// //   const navigate = useNavigate();
// //   const { data: outletData, isLoading: outletDataLoading }: any = useFetchData(
// //     useGetOutletsQuery,
// //     {
// //       body: { isPaginationRequired: false },
// //     },
// //   );
// //   const filterBy: any = [{ fieldName: 'isActive', value: true }];

// //   if (bookingCustomer) {
// //     filterBy.push({
// //       fieldName: 'bookingCustomerId',
// //       value: bookingCustomer,
// //     });
// //   }

// //   const { data: customerData, isLoading: customerLoading } = useFetchData(
// //     useGetCustomersQuery,
// //     {
// //       body: {
// //         isPaginationRequired: false,
// //         filterBy: JSON.stringify(filterBy),
// //       },
// //     },
// //   );

// //   // const { data: customerData, isLoading: customerLoading } = useFetchData(
// //   //   useGetCustomersQuery,
// //   //   {
// //   //     body: {
// //   //       isPaginationRequired: false,
// //   //       filterBy: JSON.stringify([
// //   //         {
// //   //           fieldName: 'isActive',
// //   //           value: true,
// //   //         },
// //   //         {
// //   //           fieldName: 'bookingCustomerId',
// //   //           value: bookingCustomer,
// //   //         },
// //   //       ]),
// //   //     },
// //   //   },
// //   // );

// //   const [getDraftData] = useGetDraftByIdMutation();

// //   const { isOpenAddDialog, previewNewCustomerId } = useSelector(
// //     (state: RootState) => state?.cart,
// //   );
// //   const dispatch = useDispatch<AppDispatch>();
// //   const handleGetDraftData = (draftId: string) => {
// //     getDraftData(draftId).then((res: any) => {
// //       if (res?.error) {
// //         showToast('error', res?.error?.data?.message);
// //       } else {
// //         if (res?.data?.status) {
// //           setFieldValue('customer', { _id: res?.data?.data?.customerId });
// //           setFieldValue(
// //             'items',
// //             res?.data?.data?.items?.map((item: any) => {
// //               return {
// //                 _id: item?.itemId,
// //                 // itemCode: item?.itemId,
// //                 itemName: item?.itemName,
// //                 // itemUrl: item?.itemId,
// //                 mrp: item?.mrp,
// //                 // purchasePrice: item?.itemId,
// //                 sellingPrice: item?.sellingPrice,
// //                 quantity: item?.quantity,
// //                 type: item?.itemType,
// //                 taxId: item?.taxId,
// //                 taxPercent: item?.taxPercent,
// //                 taxType: item?.taxType,
// //               };
// //             }),
// //           );
// //           setFieldValue('couponCode', res?.data?.data?.couponCode);
// //           setFieldValue('shippingCharges', res?.data?.data?.shippingCharges);
// //           setFieldValue(
// //             'amountReceived',
// //             res?.data?.data?.amountReceived?.map((el: any) => ({
// //               paymentModeId: { _id: el?.paymentModeId },
// //               amount: el?.amount?.toFixed(2),
// //             })),
// //           );
// //           setFieldValue('giftCardCode', res?.data?.data?.giftCardCode);
// //           setFieldValue('useLoyaltyPoints', res?.data?.data?.useLoyaltyPoints);
// //           setFieldValue('referralCode', res?.data?.data?.referralCode);
// //           showToast('success', res?.data?.message);
// //           dispatch(setIsOpenDraftListDialog(false));
// //         } else {
// //           showToast('error', res?.data?.message);
// //         }
// //       }
// //       // setSubmitting(false);
// //     });
// //   };
// //   useEffect(() => {
// //     if (previewNewCustomerId) {
// //       setFieldValue('customer', previewNewCustomerId);
// //       dispatch(setPreviewNewCustomerId(''));
// //     }
// //   }, [previewNewCustomerId]);

// //   // useEffect(() => {
// //   //   if (bookingCustomer && customerData && customerData?.length > 0) {
// //   //     const selectCustomer = customerData.find(
// //   //       (item) => item?.bookingCustomerId === bookingCustomer,
// //   //     );
// //   //     setFieldValue('customer', selectCustomer);
// //   //   }
// //   // }, [bookingCustomer, customerData]);
// //   const fetchCustomerByBookingId = async (
// //     bookingCustomerId: string,
// //   ): Promise<SelectOption | null> => {
// //     const filterBy = JSON.stringify([
// //       {
// //         fieldName: 'bookingCustomerId',
// //         value: bookingCustomerId,
// //       },
// //     ]);

// //     try {
// //       const response = await fetch(
// //         `${BASE_URL}/customer/pagination?isPaginationRequired=false&filterBy=${filterBy}`,
// //         {
// //           method: 'GET',
// //           headers: {
// //             Authorization: `Bearer ${accessToken}`,
// //             'Content-Type': 'application/json',
// //           },
// //         },
// //       );

// //       const result = await response.json();

// //       if (result?.data?.length > 0) {
// //         const customer: Customer = result.data[0];

// //         return {
// //           label: `${customer.customerName} - ${customer.phone} - ${customer.email}`,
// //           value: customer._id,
// //           data: customer,
// //         };
// //       }

// //       return null; // No customer found
// //     } catch (error) {
// //       // console.error('Error fetching customer by booking ID:', error);
// //       return null;
// //     }
// //   };
// //   useEffect(() => {
// //     if (bookingCustomer) {
// //       fetchCustomerByBookingId(bookingCustomer).then((customer) => {
// //         if (customer) {
// //           setSelectedCustomer(customer);
// //           setFieldValue('customer', customer.data); // ✅ Set form field value
// //         }
// //       });
// //     }
// //   }, [bookingCustomer, setFieldValue]);
// //   // const fetchOptions = async (inputValue: any): Promise<SelectOption[]> => {
// //   //   if (!inputValue) return [];

// //   //   const isNumber = /^\d+$/.test(inputValue.trim());

// //   //   try {
// //   //     const filterBy = JSON.stringify([
// //   //       {
// //   //         fieldName: isNumber ? 'phone' : 'customerName',
// //   //         value: inputValue,
// //   //       },
// //   //     ]);
// //   //     const response = await fetch(
// //   //       `${BASE_URL}/customer/pagination?isPaginationRequired=false&filterBy=${filterBy}`,
// //   //       {
// //   //         method: 'GET',
// //   //         headers: {
// //   //           Authorization: `Bearer ${accessToken}`,
// //   //           'Content-Type': 'application/json',
// //   //         },
// //   //       },
// //   //     );
// //   //     const data = await response.json();
// //   //     // console.log(data, 'data===============');

// //   //     return data?.data?.map((item: any) => ({
// //   //       label: `${item.customerName} - ${item?.phone} - ${item?.email}`,
// //   //       value: item._id,
// //   //       data: item,
// //   //     }));
// //   //   } catch (error) {
// //   //     console.error('Error fetching options:', error);
// //   //     return [];
// //   //   }
// //   // };

// //   const fetchOptions = async (inputValue: string): Promise<SelectOption[]> => {
// //     // console.log('-------calling o');
// //     if (!inputValue?.trim()) return [];

// //     const query = inputValue.trim();
// //     let filterBy: any[] = [];

// //     const isEmail = query.includes('@'); // ✅ Check email first
// //     const isNumber = /^\d+$/.test(query);

// //     if (isEmail) {
// //       filterBy = [{ fieldName: 'email', value: query }];
// //     } else if (isNumber) {
// //       filterBy = [{ fieldName: 'phone', value: query }];
// //     } else {
// //       filterBy = [{ fieldName: 'customerName', value: query }];
// //     }

// //     try {
// //       const response = await fetch(
// //         `${BASE_URL}/customer/pagination?isPaginationRequired=false&filterBy=${encodeURIComponent(
// //           JSON.stringify(filterBy)
// //         )}`,
// //         {
// //           method: 'GET',
// //           headers: {
// //             Authorization: `Bearer ${accessToken}`,
// //             'Content-Type': 'application/json',
// //           },
// //         }
// //       );

// //       if (!response.ok) {
// //         // console.error(`❌ API Error: ${response.status} ${response.statusText}`);
// //         return [];
// //       }

// //       const data = await response.json();

// //       return (data?.data || []).map((item: any) => ({
// //         label: `${item.customerName || 'Unknown'} - ${item.phone || ''} - ${item.email || ''}`,
// //         value: item._id,
// //         data: item,
// //       }));
// //     } catch (error) {
// //       // console.error('❌ Error fetching options:', error);
// //       return [];
// //     }
// //   };


// //   const debouncedLoadOptions = useDebounce(
// //     async (inputValue: any, callback: (arg0: any[]) => void) => {
// //       setLoading(true);
// //       const options = await fetchOptions(inputValue);
// //       // console.log('------options', options)
// //       setLoading(false);
// //       callback(options);
// //     },
// //     1000,
// //   );

// //   return (
// //     <div className={`flex flex-col w-full h-full gap-2 py-4 ${isDisabled ? 'pointer-events-none opacity-30' : ''}`}>
// //       <div className="flex flex-col gap-4 px-4">

// //         {/* select outlet  */}
// //         {/* {userData?.userType === 'ADMIN' && (
// //           <div className="">
// //             <ATMSelect
// //               value={outlet}
// //               onChange={(newValue) => dispatch(setOutlet(newValue))}
// //               options={outletData}
// //               valueAccessKey="_id"
// //               getOptionLabel={(option) => option?.name}
// //               placeholder="Please Select Type"
// //               isClearable={false}
// //               isLoading={outletDataLoading}
// //             />
// //           </div>
// //         )} */}
// //         {/* <div className="">
// //           <ATMButton
// //             variant="outlined"
// //             color="error"
// //             onClick={() => dispatch(setIsOpenDraftListDialog(true))}
// //           >
// //             Pick from drafts
// //           </ATMButton>
// //         </div> */}


// //         {/* Customer Search Box and add new  */}
// //         <div className="flex items-center gap-4">

// //           <div className="flex-1">
// //             {/* <ATMSelect
// //               value={values?.customer}
// //               onChange={(newValue) => {
// //                 console.log(newValue, '======newValue====');

// //                 setFieldValue('customer', newValue);
// //               }}
// //               placeholder="Select Customer"
// //               name="customer"
// //               options={customerData}
// //               label=""
// //               getOptionLabel={(option) =>
// //                 `${option?.customerName} - ${option?.phone} - ${option?.email}`
// //               }
// //               valueAccessKey="_id"
// //               isLoading={customerLoading}
// //               searchKeys={['customerName', 'phone', 'email']}
// //               filterEnabled={true}
// //             /> */}
// //             <AsyncSelect
// //               cacheOptions
// //               defaultOptions
// //               loadOptions={debouncedLoadOptions}
// //               value={selectedCustomer} // ✅ Set initial value
// //               onChange={(selectedOption: SelectOption | null) => {
// //                 setSelectedCustomer(selectedOption);
// //                 setFieldValue(
// //                   'customer',
// //                   selectedOption ? selectedOption.data : null,
// //                 );
// //               }}
// //               placeholder="Search..."
// //               isLoading={loading}
// //               isClearable
// //               isDisabled={isDisabled}
// //             />
// //           </div>

// //           <div>
// //             <ATMButton
// //               compact
// //               extraClasses={`p-2.5`}
// //               onClick={() => dispatch(setIsOpenTreatmentDialog(true))}
// //             >
// //               <IconPlaylistAdd size={14} />
// //             </ATMButton>
// //           </div>

// //           <div>
// //             <ATMButton
// //               compact
// //               extraClasses={`p-2.5`}
// //               onClick={() => dispatch(setIsOpenCustomerDialog(true))}
// //             >
// //               <IconPlus size={14} />
// //             </ATMButton>
// //           </div>
// //         </div>
// //       </div>
// //       <div className="flex flex-col flex-1 overflow-auto ">
// //         <div className="flex gap-2 p-4 py-1 text-sm font-medium text-slate-800">
// //           <div className="flex-1 truncate">Item</div>
// //           <div className="min-w-[60px]">Qty</div>
// //           <div className="min-w-[100px] text-right">Price</div>
// //           <div className="min-w-[20px]"></div>
// //         </div>

// //         <div className="flex-1 overflow-auto">
// //           {cartItems?.map((item) => {
// //             return (
// //               <div
// //                 key={item?._id}
// //                 className="flex items-center gap-2 p-4 py-2 text-slate-800 even:bg-gray-100"
// //               >
// //                 <div className="flex-1 overflow-hidden text-xs">
// //                  <div className="w-full truncate">
// //   {item?.itemName}
// //   {item?.itemCode ? ` - ${item.itemCode}` : ""}
// // </div>
// //                   <div className="font-medium text-pink-800">
// //                     {item?.sellingPrice}
// //                   </div>
// //                 </div>
// //                 <div className="min-w-[60px] flex bg-primary rounded items-center p-0.5">
// //                   <IconMinus
// //                     onClick={() => onQuantityChange(item?._id, 'DECREMENT')}
// //                     size={14}
// //                     className="text-white cursor-pointer"
// //                   />
// //                   <div className="flex justify-center flex-1 text-xs text-white select-none ">
// //                     {item?.quantity}
// //                   </div>
// //                   <IconPlus
// //                     onClick={() => onQuantityChange(item?._id, 'INCREMENT')}
// //                     size={14}
// //                     className="text-white cursor-pointer"
// //                   />
// //                 </div>
// //                 <div className="min-w-[100px] text-xs font-medium select-none text-right ">
// //                   {(item?.sellingPrice * item?.quantity).toFixed(2)}
// //                 </div>
// //                 <div
// //                   className="min-w-[20px] text-right cursor-pointer"
// //                   onClick={() => onRemove(item?._id)}
// //                 >
// //                   <IconTrash size={18} className="text-error" />
// //                 </div>
// //               </div>
// //             );
// //           })}
// //         </div>
// //       </div>

// //       {/* Amount Calculation */}
// //       <div className="border-t">
// //         {/* Total */}
// //         <div className="flex justify-end gap-2 px-4 py-1">
// //           <div
// //             className="text-base font-medium "
// //             onClick={() => setIsOpenAddNotesDialog(true)}
// //           >
// //             Notes
// //           </div>
// //         </div>
// //         <div className="flex gap-2 p-4 py-1 text-sm font-medium text-slate-800">
// //           <div className="flex-1 truncate">Total {cartItems?.length}</div>
// //           <div className="min-w-[60px]">
// //             {cartItems?.reduce((sum, item) => {
// //               return sum + item?.quantity;
// //             }, 0)}
// //           </div>
// //           <div className="min-w-[100px] text-right">
// //             {/* {CURRENCY} */}
// //             {cartItems
// //               ?.reduce((sum, item) => {
// //                 return sum + item?.quantity * item?.sellingPrice;
// //               }, 0)
// //               .toFixed(2)}
// //           </div>
// //         </div>

// //         <AmountSummaryCard items={cartItems} customer={selectedCustomer} />
// //         {isOpenAddDialog && (
// //           <PaymentFormWrapper
// //             onClose={() => dispatch(setIsOpenAddDialog(false))}
// //             items={cartItems}
// //             customerId={values?.customer}
// //             formikProps={formikProps}
// //           />
// //         )}

// //         {isOpenAddNotesDialog && (
// //           <AddNotes
// //             onClose={() => setIsOpenAddNotesDialog(false)}
// //             formType="ADD"
// //             formikProps={formikProps}
// //           />
// //         )}
// //         {isOpenDraftListDialog && (
// //           <DraftList
// //             onClose={() => dispatch(setIsOpenDraftListDialog(false))}
// //             onEdit={(item) => {
// //               handleGetDraftData(item?._id);
// //             }}
// //           />
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default CartSummarySection;


// import { IconCategory, IconMinus, IconPlaylistAdd, IconPlus, IconTrash, IconTag, IconX } from '@tabler/icons-react';
// import { FormikProps } from 'formik';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { ATMButton } from 'src/components/atoms/ATMButton/ATMButton';
// import ATMSelect from 'src/components/atoms/FormElements/ATMSelect/ATMSelect';
// import { useFetchData } from 'src/hooks/useFetchData';
// import { useGetCustomersQuery } from 'src/modules/Customer/service/CustomerServices';
// import { useGetOutletsQuery } from 'src/modules/Outlet/service/OutletServices';
// import { AppDispatch, RootState } from 'src/store';
// import { CURRENCY } from 'src/utils/constants';
// import { showToast } from 'src/utils/showToaster';
// import { useGetDraftByIdMutation } from '../service/POSServices';
// import {
//   setIsOpenAddDialog,
//   setIsOpenCustomerDialog,
//   setIsOpenDraftListDialog,
//   setPreviewNewCustomerId,
//   setIsOpenTreatmentDialog,
// } from '../slice/CartSlice';
// import DraftList from './DraftList';
// import PaymentFormWrapper from './PaymentFormWrapper';
// import AddNotes from './AddNotes';
// import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import AsyncSelect from 'react-select/async';
// import { BASE_URL } from '../../../utils/constants/index';

// // ============================================================
// // TYPES
// // ============================================================
// type DiscountType = 'FLAT' | 'PERCENTAGE';
// type DiscountValue = { type: DiscountType; value: number } | null;

// type AmountSummaryCardProps = {
//   items: any[];
//   customer: any;
//   discount: DiscountValue;
//   onOpenDiscount: () => void;
// };

// interface Customer {
//   _id: string;
//   bookingCustomerId: string;
//   customerName: string;
//   email: string;
//   phone: string;
//   isActive: boolean;
//   isDeleted: boolean;
// }

// interface SelectOption {
//   label: string;
//   value: string;
//   data: Customer;
// }

// // ============================================================
// // AMOUNT CALCULATION HELPER
// // ============================================================
// export const calculatedAmounts = (items: any) => {
//   let taxes: {
//     taxType: string;
//     taxAmount: number;
//     taxPercent: number;
//   }[] = [];
//   let totalAmount = 0;

//   items?.forEach((item: any) => {
//     const matchedIndex = taxes?.findIndex(
//       (el: any) => el?.taxType === item?.taxType,
//     );
//     if (matchedIndex > -1) {
//       taxes[matchedIndex].taxAmount +=
//         (item?.quantity * item?.sellingPrice * item?.taxPercent || 0) / 100;
//     } else {
//       taxes?.push({
//         taxType: item?.taxType,
//         taxPercent: item?.taxPercent,
//         taxAmount:
//           (item?.quantity * item?.sellingPrice * item?.taxPercent || 0) / 100,
//       });
//     }

//     totalAmount +=
//       Number(item?.sellingPrice) *
//       Number(item?.quantity) *
//       ((100 + (Number(item?.taxPercent) || 0)) / 100);
//   });

//   return {
//     taxes,
//     totalAmount: totalAmount?.toFixed(2),
//   };
// };

// // ============================================================
// // DISCOUNT CALC HELPER
// // ============================================================
// const calculateDiscountAmount = (
//   total: number,
//   discount: DiscountValue
// ): number => {
//   if (!discount || !discount.value || discount.value <= 0) return 0;
//   if (discount.type === 'FLAT') {
//     return Math.min(discount.value, total);
//   }
//   return Math.min((total * discount.value) / 100, total);
// };

// // ============================================================
// // DISCOUNT MODAL
// // ============================================================
// const DiscountModal = ({
//   onClose,
//   onApply,
//   initial,
//   totalAmount,
// }: {
//   onClose: () => void;
//   onApply: (d: DiscountValue) => void;
//   initial: DiscountValue;
//   totalAmount: number;
// }) => {
//   const [type, setType] = useState<DiscountType>(initial?.type || 'FLAT');
//   const [value, setValue] = useState<string>(
//     initial?.value ? String(initial.value) : ''
//   );

//   const numericValue = Number(value) || 0;

//   const discountAmount =
//     type === 'FLAT'
//       ? Math.min(numericValue, totalAmount)
//       : Math.min((totalAmount * numericValue) / 100, totalAmount);

//   const finalAmount = Math.max(0, totalAmount - discountAmount);

//   const handleApply = () => {
//     if (!numericValue || numericValue <= 0) {
//       showToast('error', 'Please enter a valid discount value');
//       return;
//     }
//     if (type === 'PERCENTAGE' && numericValue > 100) {
//       showToast('error', 'Percentage cannot exceed 100');
//       return;
//     }
//     if (type === 'FLAT' && numericValue > totalAmount) {
//       showToast('error', 'Discount cannot exceed total amount');
//       return;
//     }
//     onApply({ type, value: numericValue });
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-xl w-full max-w-md p-6 space-y-4 shadow-xl">
//         {/* Header */}
//         <div className="flex justify-between items-center border-b pb-2">
//           <div className="flex items-center gap-2">
//             <IconTag size={18} className="text-primary" />
//             <h2 className="text-lg font-semibold">Add Discount</h2>
//           </div>
//           <button
//             onClick={onClose}
//             className="text-slate-500 hover:text-slate-800"
//             type="button"
//           >
//             <IconX size={20} />
//           </button>
//         </div>

//         {/* Type Toggle */}
//         <div className="flex gap-2 bg-gray-100 p-1 rounded-lg">
//           <button
//             type="button"
//             onClick={() => setType('FLAT')}
//             className={`flex-1 py-2 rounded-md text-sm font-medium transition ${
//               type === 'FLAT'
//                 ? 'bg-primary text-white shadow'
//                 : 'text-slate-600 hover:bg-gray-200'
//             }`}
//           >
//             Flat ({CURRENCY})
//           </button>
//           <button
//             type="button"
//             onClick={() => setType('PERCENTAGE')}
//             className={`flex-1 py-2 rounded-md text-sm font-medium transition ${
//               type === 'PERCENTAGE'
//                 ? 'bg-primary text-white shadow'
//                 : 'text-slate-600 hover:bg-gray-200'
//             }`}
//           >
//             Percentage (%)
//           </button>
//         </div>

//         {/* Value Input */}
//         <div>
//           <label className="text-sm font-medium text-slate-700">
//             {type === 'FLAT'
//               ? `Discount Amount (${CURRENCY})`
//               : 'Discount Percentage (%)'}
//           </label>
//           <input
//             type="number"
//             min="0"
//             max={type === 'PERCENTAGE' ? 100 : undefined}
//             step="0.01"
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             placeholder={
//               type === 'FLAT' ? 'Enter amount' : 'Enter percentage'
//             }
//             className="w-full border rounded-lg p-2.5 mt-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
//             autoFocus
//           />
//         </div>

//         {/* Live Preview */}
//         {numericValue > 0 && (
//           <div className="bg-gray-50 rounded-lg p-3 text-sm space-y-1.5">
//             <div className="flex justify-between">
//               <span className="text-slate-600">Total</span>
//               <span className="font-medium">
//                 {CURRENCY} {totalAmount.toFixed(2)}
//               </span>
//             </div>
//             <div className="flex justify-between">
//               <span className="text-slate-600">Discount</span>
//               <span className="font-medium text-red-600">
//                 - {CURRENCY} {discountAmount.toFixed(2)}
//               </span>
//             </div>
//             <div className="flex justify-between border-t pt-1.5 mt-1.5">
//               <span className="font-semibold">Final Amount</span>
//               <span className="font-bold text-primary">
//                 {CURRENCY} {finalAmount.toFixed(2)}
//               </span>
//             </div>
//           </div>
//         )}

//         {/* Actions */}
//         <div className="flex gap-2 pt-2">
//           <ATMButton
//             variant="outlined"
//             onClick={onClose}
//             extraClasses="flex-1"
//           >
//             Cancel
//           </ATMButton>
//           {initial && (
//             <ATMButton
//               variant="outlined"
//               color="error"
//               onClick={() => {
//                 onApply(null);
//                 onClose();
//               }}
//               extraClasses="flex-1"
//             >
//               Remove
//             </ATMButton>
//           )}
//           <ATMButton onClick={handleApply} extraClasses="flex-1">
//             Apply
//           </ATMButton>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ============================================================
// // AMOUNT SUMMARY CARD
// // ============================================================
// const AmountSummaryCard = ({
//   items,
//   customer,
//   discount,
//   onOpenDiscount,
// }: AmountSummaryCardProps) => {
//   const dispatch = useDispatch<AppDispatch>();

//   const { taxes, totalAmount } = calculatedAmounts(items);
//   const numericTotal = Number(totalAmount) || 0;
//   const discountAmount = calculateDiscountAmount(numericTotal, discount);
//   const finalAmount = Math.max(0, numericTotal - discountAmount);

//   return (
//     <div className="flex flex-col gap-2 space-y-1">
//       <div>
//         {/* Taxes */}
//         <div>
//           {taxes?.map((tax: any, index) => (
//             <div key={index} className="flex gap-2 p-4 py-1">
//               <div className="flex-1 text-xs truncate text-slate-500">
//                 {tax?.taxType && tax?.taxPercent ? (
//                   <div>
//                     {tax?.taxType} @ {tax?.taxPercent}%
//                   </div>
//                 ) : null}
//               </div>
//               {tax?.taxAmount ? (
//                 <div className="min-w-[60px] text-sm text-slate-600 text-right">
//                   {CURRENCY} {tax?.taxAmount.toFixed(2)}
//                 </div>
//               ) : null}
//             </div>
//           ))}
//         </div>

//         {/* Sub Total */}
//         <div className="flex gap-2 px-4 py-1 bg-yellow-100">
//           <div className="flex-1 text-base font-medium">Sub Total</div>
//           <div className="min-w-[60px] text-base font-medium text-slate-800 text-right">
//             {CURRENCY} {numericTotal.toFixed(2)}
//           </div>
//         </div>

//         {/* Discount Row */}
//         {discount && discountAmount > 0 && (
//           <div className="flex gap-2 px-4 py-1 bg-red-50">
//             <div className="flex-1 text-sm font-medium text-red-700">
//               Discount
//               {discount.type === 'PERCENTAGE' ? ` (${discount.value}%)` : ''}
//             </div>
//             <div className="min-w-[60px] text-sm font-semibold text-red-600 text-right">
//               - {CURRENCY} {discountAmount.toFixed(2)}
//             </div>
//           </div>
//         )}

//         {/* Final Amount */}
//         {discount && discountAmount > 0 && (
//           <div className="flex gap-2 px-4 py-1 bg-green-100">
//             <div className="flex-1 text-base font-bold text-green-800">
//               Final Amount
//             </div>
//             <div className="min-w-[60px] text-base font-bold text-green-800 text-right">
//               {CURRENCY} {finalAmount.toFixed(2)}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="px-4">
//         <ATMButton
//           onClick={() => dispatch(setIsOpenAddDialog(true))}
//           children="Pay Now"
//           disabled={!customer}
//         />
//       </div>
//     </div>
//   );
// };

// // ============================================================
// // PROPS + DEBOUNCE HELPER
// // ============================================================
// type Props = {
//   cartItems: any[];
//   onRemove: (itemId: string) => void;
//   onQuantityChange: (itemId: string, type: 'INCREMENT' | 'DECREMENT') => void;
//   formikProps: FormikProps<any>;
//   isDisabled: boolean;
// };

// const useDebounce = (callback: Function, delay: number) => {
//   const timerRef = useRef<NodeJS.Timeout | null>(null);

//   return useCallback(
//     (...args: any[]) => {
//       if (timerRef.current) clearTimeout(timerRef.current);
//       timerRef.current = setTimeout(() => {
//         callback(...args);
//       }, delay);
//     },
//     [callback, delay],
//   );
// };

// // ============================================================
// // MAIN COMPONENT
// // ============================================================
// const CartSummarySection = ({
//   cartItems,
//   onRemove,
//   onQuantityChange,
//   formikProps,
//   isDisabled,
// }: Props) => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const bookingCustomer = searchParams.get('customer');
//   const [loading, setLoading] = useState(false);
//   const [selectedCustomer, setSelectedCustomer] = useState<SelectOption | null>(
//     null,
//   );

//   const { values, setFieldValue } = formikProps;
//   const [isOpenAddNotesDialog, setIsOpenAddNotesDialog] = useState(false);
//   const [isOpenDiscountModal, setIsOpenDiscountModal] = useState(false);

//   const { userData, outlet, accessToken } = useSelector(
//     (state: RootState) => state.auth,
//   );

//   const { isOpenDraftListDialog, isOpenCustomerDialog } = useSelector(
//     (state: RootState) => state.cart,
//   );
//   const navigate = useNavigate();

//   const { data: outletData, isLoading: outletDataLoading }: any = useFetchData(
//     useGetOutletsQuery,
//     {
//       body: { isPaginationRequired: false },
//     },
//   );

//   const filterBy: any = [{ fieldName: 'isActive', value: true }];
//   if (bookingCustomer) {
//     filterBy.push({
//       fieldName: 'bookingCustomerId',
//       value: bookingCustomer,
//     });
//   }

//   const { data: customerData, isLoading: customerLoading } = useFetchData(
//     useGetCustomersQuery,
//     {
//       body: {
//         isPaginationRequired: false,
//         filterBy: JSON.stringify(filterBy),
//       },
//     },
//   );

//   const [getDraftData] = useGetDraftByIdMutation();

//   const { isOpenAddDialog, previewNewCustomerId } = useSelector(
//     (state: RootState) => state?.cart,
//   );
//   const dispatch = useDispatch<AppDispatch>();

//   // ✅ Discount from Formik
//   const discount: DiscountValue = values?.discount || null;

//   const handleGetDraftData = (draftId: string) => {
//     getDraftData(draftId).then((res: any) => {
//       if (res?.error) {
//         showToast('error', res?.error?.data?.message);
//       } else {
//         if (res?.data?.status) {
//           setFieldValue('customer', { _id: res?.data?.data?.customerId });
//           setFieldValue(
//             'items',
//             res?.data?.data?.items?.map((item: any) => {
//               return {
//                 _id: item?.itemId,
//                 itemName: item?.itemName,
//                 mrp: item?.mrp,
//                 sellingPrice: item?.sellingPrice,
//                 quantity: item?.quantity,
//                 type: item?.itemType,
//                 taxId: item?.taxId,
//                 taxPercent: item?.taxPercent,
//                 taxType: item?.taxType,
//               };
//             }),
//           );
//           setFieldValue('couponCode', res?.data?.data?.couponCode);
//           setFieldValue('shippingCharges', res?.data?.data?.shippingCharges);
//           setFieldValue(
//             'amountReceived',
//             res?.data?.data?.amountReceived?.map((el: any) => ({
//               paymentModeId: { _id: el?.paymentModeId },
//               amount: el?.amount?.toFixed(2),
//             })),
//           );
//           setFieldValue('giftCardCode', res?.data?.data?.giftCardCode);
//           setFieldValue('useLoyaltyPoints', res?.data?.data?.useLoyaltyPoints);
//           setFieldValue('referralCode', res?.data?.data?.referralCode);
//           // ✅ Draft discount bhi load karo (agar aaya ho)
//           setFieldValue('discount', res?.data?.data?.discount || null);
//           showToast('success', res?.data?.message);
//           dispatch(setIsOpenDraftListDialog(false));
//         } else {
//           showToast('error', res?.data?.message);
//         }
//       }
//     });
//   };

//   useEffect(() => {
//     if (previewNewCustomerId) {
//       setFieldValue('customer', previewNewCustomerId);
//       dispatch(setPreviewNewCustomerId(''));
//     }
//   }, [previewNewCustomerId]);

//   const fetchCustomerByBookingId = async (
//     bookingCustomerId: string,
//   ): Promise<SelectOption | null> => {
//     const filterBy = JSON.stringify([
//       {
//         fieldName: 'bookingCustomerId',
//         value: bookingCustomerId,
//       },
//     ]);

//     try {
//       const response = await fetch(
//         `${BASE_URL}/customer/pagination?isPaginationRequired=false&filterBy=${filterBy}`,
//         {
//           method: 'GET',
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             'Content-Type': 'application/json',
//           },
//         },
//       );

//       const result = await response.json();

//       if (result?.data?.length > 0) {
//         const customer: Customer = result.data[0];

//         return {
//           label: `${customer.customerName} - ${customer.phone} - ${customer.email}`,
//           value: customer._id,
//           data: customer,
//         };
//       }

//       return null;
//     } catch (error) {
//       return null;
//     }
//   };

//   useEffect(() => {
//     if (bookingCustomer) {
//       fetchCustomerByBookingId(bookingCustomer).then((customer) => {
//         if (customer) {
//           setSelectedCustomer(customer);
//           setFieldValue('customer', customer.data);
//         }
//       });
//     }
//   }, [bookingCustomer, setFieldValue]);

//   const fetchOptions = async (inputValue: string): Promise<SelectOption[]> => {
//     if (!inputValue?.trim()) return [];

//     const query = inputValue.trim();
//     let filterBy: any[] = [];

//     const isEmail = query.includes('@');
//     const isNumber = /^\d+$/.test(query);

//     if (isEmail) {
//       filterBy = [{ fieldName: 'email', value: query }];
//     } else if (isNumber) {
//       filterBy = [{ fieldName: 'phone', value: query }];
//     } else {
//       filterBy = [{ fieldName: 'customerName', value: query }];
//     }

//     try {
//       const response = await fetch(
//         `${BASE_URL}/customer/pagination?isPaginationRequired=false&filterBy=${encodeURIComponent(
//           JSON.stringify(filterBy)
//         )}`,
//         {
//           method: 'GET',
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (!response.ok) return [];

//       const data = await response.json();

//       return (data?.data || []).map((item: any) => ({
//         label: `${item.customerName || 'Unknown'} - ${item.phone || ''} - ${item.email || ''}`,
//         value: item._id,
//         data: item,
//       }));
//     } catch (error) {
//       return [];
//     }
//   };

//   const debouncedLoadOptions = useDebounce(
//     async (inputValue: any, callback: (arg0: any[]) => void) => {
//       setLoading(true);
//       const options = await fetchOptions(inputValue);
//       setLoading(false);
//       callback(options);
//     },
//     1000,
//   );

//   // ✅ Current total (for discount modal)
//   const currentTotal = useMemo(
//     () => Number(calculatedAmounts(cartItems)?.totalAmount || 0),
//     [cartItems]
//   );

//   return (
//     <div className={`flex flex-col w-full h-full gap-2 py-4 ${isDisabled ? 'pointer-events-none opacity-30' : ''}`}>
//       <div className="flex flex-col gap-4 px-4">
//         {/* Customer Search + Buttons */}
//         <div className="flex items-center gap-4">
//           <div className="flex-1">
//             <AsyncSelect
//               cacheOptions
//               defaultOptions
//               loadOptions={debouncedLoadOptions}
//               value={selectedCustomer}
//               onChange={(selectedOption: SelectOption | null) => {
//                 setSelectedCustomer(selectedOption);
//                 setFieldValue(
//                   'customer',
//                   selectedOption ? selectedOption.data : null,
//                 );
//               }}
//               placeholder="Search..."
//               isLoading={loading}
//               isClearable
//               isDisabled={isDisabled}
//             />
//           </div>

//           <div>
//             <ATMButton
//               compact
//               extraClasses={`p-2.5`}
//               onClick={() => dispatch(setIsOpenTreatmentDialog(true))}
//             >
//               <IconPlaylistAdd size={14} />
//             </ATMButton>
//           </div>

//           <div>
//             <ATMButton
//               compact
//               extraClasses={`p-2.5`}
//               onClick={() => dispatch(setIsOpenCustomerDialog(true))}
//             >
//               <IconPlus size={14} />
//             </ATMButton>
//           </div>
//         </div>
//       </div>

//       {/* Items List */}
//       <div className="flex flex-col flex-1 overflow-auto">
//         <div className="flex gap-2 p-4 py-1 text-sm font-medium text-slate-800">
//           <div className="flex-1 truncate">Item</div>
//           <div className="min-w-[60px]">Qty</div>
//           <div className="min-w-[100px] text-right">Price</div>
//           <div className="min-w-[20px]"></div>
//         </div>

//         <div className="flex-1 overflow-auto">
//           {cartItems?.map((item) => {
//             return (
//               <div
//                 key={item?._id}
//                 className="flex items-center gap-2 p-4 py-2 text-slate-800 even:bg-gray-100"
//               >
//                 <div className="flex-1 overflow-hidden text-xs">
//                   <div className="w-full truncate">
//                     {item?.itemName}
//                     {item?.itemCode ? ` - ${item.itemCode}` : ''}
//                   </div>
//                   <div className="font-medium text-pink-800">
//                     {item?.sellingPrice}
//                   </div>
//                 </div>
//                 <div className="min-w-[60px] flex bg-primary rounded items-center p-0.5">
//                   <IconMinus
//                     onClick={() => onQuantityChange(item?._id, 'DECREMENT')}
//                     size={14}
//                     className="text-white cursor-pointer"
//                   />
//                   <div className="flex justify-center flex-1 text-xs text-white select-none">
//                     {item?.quantity}
//                   </div>
//                   <IconPlus
//                     onClick={() => onQuantityChange(item?._id, 'INCREMENT')}
//                     size={14}
//                     className="text-white cursor-pointer"
//                   />
//                 </div>
//                 <div className="min-w-[100px] text-xs font-medium select-none text-right">
//                   {(item?.sellingPrice * item?.quantity).toFixed(2)}
//                 </div>
//                 <div
//                   className="min-w-[20px] text-right cursor-pointer"
//                   onClick={() => onRemove(item?._id)}
//                 >
//                   <IconTrash size={18} className="text-error" />
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Amount Calculation */}
//       <div className="border-t">
//         {/* Notes + Add Discount */}
//         <div className="flex justify-end gap-4 px-4 py-1">
//           <div
//             className="text-base font-medium cursor-pointer text-primary hover:underline"
//             onClick={() => setIsOpenAddNotesDialog(true)}
//           >
//             Notes
//           </div>

//           <div
//             className="text-base font-medium cursor-pointer text-primary hover:underline flex items-center gap-1"
//             onClick={() => setIsOpenDiscountModal(true)}
//           >
//             <IconTag size={16} />
//             {discount ? 'Edit Discount' : 'Add Discount'}
//           </div>
//         </div>

//         {/* Totals row */}
//         <div className="flex gap-2 p-4 py-1 text-sm font-medium text-slate-800">
//           <div className="flex-1 truncate">Total {cartItems?.length}</div>
//           <div className="min-w-[60px]">
//             {cartItems?.reduce((sum, item) => {
//               return sum + item?.quantity;
//             }, 0)}
//           </div>
//           <div className="min-w-[100px] text-right">
//             {cartItems
//               ?.reduce((sum, item) => {
//                 return sum + item?.quantity * item?.sellingPrice;
//               }, 0)
//               .toFixed(2)}
//           </div>
//         </div>

//         <AmountSummaryCard
//           items={cartItems}
//           customer={selectedCustomer}
//           discount={discount}
//           onOpenDiscount={() => setIsOpenDiscountModal(true)}
//         />

//         {/* Pay Now Modal */}
//         {isOpenAddDialog && (
//           <PaymentFormWrapper
//             onClose={() => dispatch(setIsOpenAddDialog(false))}
//             items={cartItems}
//             customerId={values?.customer}
//             formikProps={formikProps}
//           />
//         )}

//         {/* Notes Modal */}
//         {isOpenAddNotesDialog && (
//           <AddNotes
//             onClose={() => setIsOpenAddNotesDialog(false)}
//             formType="ADD"
//             formikProps={formikProps}
//           />
//         )}

//         {/* ✅ Discount Modal */}
//         {isOpenDiscountModal && (
//           <DiscountModal
//             onClose={() => setIsOpenDiscountModal(false)}
//             onApply={(d) => setFieldValue('discount', d)}
//             initial={discount}
//             totalAmount={currentTotal}
//           />
//         )}

//         {/* Draft List Modal */}
//         {isOpenDraftListDialog && (
//           <DraftList
//             onClose={() => dispatch(setIsOpenDraftListDialog(false))}
//             onEdit={(item) => {
//               handleGetDraftData(item?._id);
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default CartSummarySection;


import { IconCategory, IconMinus, IconPlaylistAdd, IconPlus, IconTrash, IconTag, IconX } from '@tabler/icons-react';
import { FormikProps } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ATMButton } from 'src/components/atoms/ATMButton/ATMButton';
import ATMSelect from 'src/components/atoms/FormElements/ATMSelect/ATMSelect';
import { useFetchData } from 'src/hooks/useFetchData';
import { useGetCustomersQuery } from 'src/modules/Customer/service/CustomerServices';
import { useGetOutletsQuery } from 'src/modules/Outlet/service/OutletServices';
import { AppDispatch, RootState } from 'src/store';
import { CURRENCY } from 'src/utils/constants';
import { showToast } from 'src/utils/showToaster';
import { useGetDraftByIdMutation } from '../service/POSServices';
import {
  setIsOpenAddDialog,
  setIsOpenCustomerDialog,
  setIsOpenDraftListDialog,
  setPreviewNewCustomerId,
  setIsOpenTreatmentDialog,
} from '../slice/CartSlice';
import DraftList from './DraftList';
import PaymentFormWrapper from './PaymentFormWrapper';
import AddNotes from './AddNotes';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import { BASE_URL } from '../../../utils/constants/index';
import ShowConfirmation from 'src/utils/ShowConfirmation';
import { useLazyGetRewardsCouponsQuery } from 'src/modules/RewardsCoupon/service/RewardsCouponServices';

// ============================================================
// TYPES
// ============================================================
type DiscountType = 'FLAT' | 'PERCENTAGE';
type DiscountValue = { type: DiscountType; value: number } | null;

type GiftCardConfig = {
  couponCode: string;
  physicalNumber: string;
  amount: number;
  configured: boolean;
};

type AmountSummaryCardProps = {
  items: any[];
  customer: any;
  discount: DiscountValue;
  onOpenDiscount: () => void;
};

interface Customer {
  _id: string;
  bookingCustomerId: string;
  customerName: string;
  email: string;
  phone: string;
  isActive: boolean;
  isDeleted: boolean;
}

interface SelectOption {
  label: string;
  value: string;
  data: Customer;
}

// ============================================================
// AMOUNT CALCULATION HELPER
// ============================================================
export const calculatedAmounts = (items: any) => {
  let taxes: {
    taxType: string;
    taxAmount: number;
    taxPercent: number;
  }[] = [];
  let totalAmount = 0;

  items?.forEach((item: any) => {
    const matchedIndex = taxes?.findIndex(
      (el: any) => el?.taxType === item?.taxType,
    );
    if (matchedIndex > -1) {
      taxes[matchedIndex].taxAmount +=
        (item?.quantity * item?.sellingPrice * item?.taxPercent || 0) / 100;
    } else {
      taxes?.push({
        taxType: item?.taxType,
        taxPercent: item?.taxPercent,
        taxAmount:
          (item?.quantity * item?.sellingPrice * item?.taxPercent || 0) / 100,
      });
    }

    totalAmount +=
      Number(item?.sellingPrice) *
      Number(item?.quantity) *
      ((100 + (Number(item?.taxPercent) || 0)) / 100);
  });

  return {
    taxes,
    totalAmount: totalAmount?.toFixed(2),
  };
};

// ============================================================
// DISCOUNT CALC HELPER
// ============================================================
const calculateDiscountAmount = (
  total: number,
  discount: DiscountValue
): number => {
  if (!discount || !discount.value || discount.value <= 0) return 0;
  if (discount.type === 'FLAT') {
    return Math.min(discount.value, total);
  }
  return Math.min((total * discount.value) / 100, total);
};

// ============================================================
// DISCOUNT MODAL
// ============================================================
const DiscountModal = ({
  onClose,
  onApply,
  initial,
  totalAmount,
}: {
  onClose: () => void;
  onApply: (d: DiscountValue) => void;
  initial: DiscountValue;
  totalAmount: number;
}) => {
  const [type, setType] = useState<DiscountType>(initial?.type || 'FLAT');
  const [value, setValue] = useState<string>(
    initial?.value ? String(initial.value) : ''
  );

  const numericValue = Number(value) || 0;

  const discountAmount =
    type === 'FLAT'
      ? Math.min(numericValue, totalAmount)
      : Math.min((totalAmount * numericValue) / 100, totalAmount);

  const finalAmount = Math.max(0, totalAmount - discountAmount);

  const handleApply = () => {
    if (!numericValue || numericValue <= 0) {
      showToast('error', 'Please enter a valid discount value');
      return;
    }
    if (type === 'PERCENTAGE' && numericValue > 100) {
      showToast('error', 'Percentage cannot exceed 100');
      return;
    }
    if (type === 'FLAT' && numericValue > totalAmount) {
      showToast('error', 'Discount cannot exceed total amount');
      return;
    }
    onApply({ type, value: numericValue });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md p-6 space-y-4 shadow-xl">
        <div className="flex justify-between items-center border-b pb-2">
          <div className="flex items-center gap-2">
            <IconTag size={18} className="text-primary" />
            <h2 className="text-lg font-semibold">Add Discount</h2>
          </div>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-slate-800"
            type="button"
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="flex gap-2 bg-gray-100 p-1 rounded-lg">
          <button
            type="button"
            onClick={() => setType('FLAT')}
            className={`flex-1 py-2 rounded-md text-sm font-medium transition ${
              type === 'FLAT'
                ? 'bg-primary text-white shadow'
                : 'text-slate-600 hover:bg-gray-200'
            }`}
          >
            Flat ({CURRENCY})
          </button>
          <button
            type="button"
            onClick={() => setType('PERCENTAGE')}
            className={`flex-1 py-2 rounded-md text-sm font-medium transition ${
              type === 'PERCENTAGE'
                ? 'bg-primary text-white shadow'
                : 'text-slate-600 hover:bg-gray-200'
            }`}
          >
            Percentage (%)
          </button>
        </div>

        <div>
          <label className="text-sm font-medium text-slate-700">
            {type === 'FLAT'
              ? `Discount Amount (${CURRENCY})`
              : 'Discount Percentage (%)'}
          </label>
          <input
            type="number"
            min="0"
            max={type === 'PERCENTAGE' ? 100 : undefined}
            step="0.01"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={
              type === 'FLAT' ? 'Enter amount' : 'Enter percentage'
            }
            className="w-full border rounded-lg p-2.5 mt-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
            autoFocus
          />
        </div>

        {numericValue > 0 && (
          <div className="bg-gray-50 rounded-lg p-3 text-sm space-y-1.5">
            <div className="flex justify-between">
              <span className="text-slate-600">Total</span>
              <span className="font-medium">
                {CURRENCY} {totalAmount.toFixed(2)}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">Discount</span>
              <span className="font-medium text-red-600">
                - {CURRENCY} {discountAmount.toFixed(2)}
              </span>
            </div>
            <div className="flex justify-between border-t pt-1.5 mt-1.5">
              <span className="font-semibold">Final Amount</span>
              <span className="font-bold text-primary">
                {CURRENCY} {finalAmount.toFixed(2)}
              </span>
            </div>
          </div>
        )}

        <div className="flex gap-2 pt-2">
          <ATMButton
            variant="outlined"
            onClick={onClose}
            extraClasses="flex-1"
          >
            Cancel
          </ATMButton>
          {initial && (
            <ATMButton
              variant="outlined"
              color="error"
              onClick={() => {
                onApply(null);
                onClose();
              }}
              extraClasses="flex-1"
            >
              Remove
            </ATMButton>
          )}
          <ATMButton onClick={handleApply} extraClasses="flex-1">
            Apply
          </ATMButton>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// GIFT CARD MODAL — NO API CALL, only config
// ============================================================
// const GiftCardModal = ({
//   item,
//   config,
//   onClose,
//   onApply,
// }: {
//   item: any;
//   config: GiftCardConfig;
//   onClose: () => void;
//   onApply: (updated: { physicalNumber: string; amount: number }) => void;
// }) => {
//   const [physicalNumber, setPhysicalNumber] = useState(
//     config?.physicalNumber || config?.couponCode || ''
//   );
//   const [amount, setAmount] = useState<number>(
//     config?.amount || Number(item?.sellingPrice) || 0
//   );

//   const handleSave = () => {
//     if (!physicalNumber?.trim()) {
//       showToast('error', 'Please enter physical card number');
//       return;
//     }
//     if (!amount || Number(amount) <= 0) {
//       showToast('error', 'Please enter valid gift card amount');
//       return;
//     }
//     onApply({
//       physicalNumber: physicalNumber.trim().toUpperCase(),
//       amount: Number(amount),
//     });
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-xl w-full max-w-md p-6 space-y-4 shadow-xl">
//         <div className="flex justify-between items-center border-b pb-2">
//           <h2 className="text-lg font-semibold">Configure Gift Card</h2>
//           <button
//             onClick={onClose}
//             className="text-slate-500 hover:text-slate-800"
//             type="button"
//           >
//             <IconX size={20} />
//           </button>
//         </div>

//         <div className="bg-gray-50 rounded-lg p-3">
//           <p className="text-xs text-gray-500">Service</p>
//           <p className="font-medium text-sm">{item?.itemName}</p>
//           <p className="text-xs text-gray-500 mt-1">
//             Generated Code:{' '}
//             <span className="font-mono font-bold text-primary">
//               {config?.couponCode}
//             </span>
//           </p>
//         </div>

//         <div>
//           <label className="text-sm font-medium text-slate-700">
//             Physical Card Number <span className="text-red-500">*</span>
//           </label>
//           <input
//             type="text"
//             value={physicalNumber}
//             onChange={(e) => setPhysicalNumber(e.target.value.toUpperCase())}
//             placeholder="e.g. GC-001, GIFT-12345"
//             className="w-full border rounded-lg p-2.5 mt-1 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-primary/40"
//             autoFocus
//           />
//          <p className="text-xs text-gray-500 mt-1">
//   Enter the physical card number. Each card must have a unique code.
// </p>
//         </div>

//         <div>
//           <label className="text-sm font-medium text-slate-700">
//             Gift Card Amount <span className="text-red-500">*</span>
//           </label>
//           <input
//             type="number"
//             min="0"
//             step="0.01"
//             value={amount}
//             onChange={(e) => setAmount(Number(e.target.value))}
//             className="w-full border rounded-lg p-2.5 mt-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
//           />
//           <p className="text-xs text-gray-500 mt-1">
//             Customer can redeem services up to this amount
//           </p>
//         </div>

//         {/* <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 text-xs text-blue-800">
//           ℹ️ Coupon payment ke time create hoga. Abhi sirf configuration save
//           ho rahi hai.
//         </div> */}

//         <div className="flex gap-2 pt-2">
//           <ATMButton
//             variant="outlined"
//             onClick={onClose}
//             extraClasses="flex-1"
//           >
//             Cancel
//           </ATMButton>
//           <ATMButton onClick={handleSave} extraClasses="flex-1">
//             Save Configuration
//           </ATMButton>
//         </div>
//       </div>
//     </div>
//   );
// };

const GiftCardModal = ({
  item,
  config,
  onClose,
  onApply,
}: {
  item: any;
  config: GiftCardConfig;
  onClose: () => void;
  onApply: (updated: { physicalNumber: string; amount: number }) => void;
}) => {
  const [physicalNumber, setPhysicalNumber] = useState(
    config?.physicalNumber || config?.couponCode || ''
  );
  const [amount, setAmount] = useState<number>(
    config?.amount || Number(item?.sellingPrice) || 0
  );

  // ✅ Lazy Query hook for validation (API call on button click)
  const [checkGiftCard, { isFetching: isChecking }] =
    useLazyGetRewardsCouponsQuery();

   const handleSave = async () => {
    if (!physicalNumber?.trim()) {
      showToast('error', 'Please enter physical card number');
      return;
    }
    if (!amount || Number(amount) <= 0) {
      showToast('error', 'Please enter valid gift card amount');
      return;
    }

    const formattedCode = physicalNumber.trim().toUpperCase();

    // 🔥 CHECK: Agar cashier ne auto-generated number change kiya hai
    if (formattedCode !== config?.couponCode) {
      ShowConfirmation({
        type: 'INFO',
        title: 'Change Gift Card Number?',
        message: `Do you really want to change the gift card number from ${config?.couponCode} to ${formattedCode}?`,
        confirmationText: 'Yes, Change',
        onConfirm: async (closeDialog) => {
          closeDialog();
          await executeSave(formattedCode); // Niche wala function call hoga
        },
      });
      return;
    }

    // Agar number change nahi kiya, toh direct save
    await executeSave(formattedCode);
  };

  // Naya helper function
  const executeSave = async (formattedCode: string) => {
    try {
      const res: any = await checkGiftCard({
        isPaginationRequired: false,
        filterBy: JSON.stringify([{ fieldName: 'couponCode', value: formattedCode }]),
      }).unwrap();

      const allCards = res?.data || res?.data?.data || [];
      const hasActiveBalance = allCards.some(
        (c: any) =>
          String(c.couponCode || '').trim().toUpperCase() === formattedCode &&
          c.isActive === true &&
          Number(c.balanceAmount) > 0
      );

      if (hasActiveBalance) {
        showToast('error', 'This physical card number is currently active with a remaining balance and cannot be reissued.');
        return;
      }

      onApply({ physicalNumber: formattedCode, amount: Number(amount) });
      onClose();
    } catch (error) {
      showToast('error', 'Failed to validate gift card number.');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md p-6 space-y-4 shadow-xl">
        <div className="flex justify-between items-center border-b pb-2">
          <h2 className="text-lg font-semibold">Configure Gift Card</h2>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-slate-800"
            type="button"
            disabled={isChecking}
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="bg-gray-50 rounded-lg p-3">
          <p className="text-xs text-gray-500">Service</p>
          <p className="font-medium text-sm">{item?.itemName}</p>
          <p className="text-xs text-gray-500 mt-1">
            Generated Code:{' '}
            <span className="font-mono font-bold text-primary">
              {config?.couponCode}
            </span>
          </p>
        </div>

        <div>
          <label className="text-sm font-medium text-slate-700">
            Physical Card Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={physicalNumber}
            onChange={(e) => setPhysicalNumber(e.target.value.toUpperCase())}
            placeholder="e.g. GC-001, GIFT-12345"
            className="w-full border rounded-lg p-2.5 mt-1 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-primary/40"
            autoFocus
            disabled={isChecking}
          />
          <p className="text-xs text-gray-500 mt-1">
            Enter the physical card number. Each card must have a unique code.
          </p>
        </div>

        <div>
          <label className="text-sm font-medium text-slate-700">
            Gift Card Amount <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value))}
            className="w-full border rounded-lg p-2.5 mt-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
            disabled={isChecking}
          />
          <p className="text-xs text-gray-500 mt-1">
            Customer can redeem services up to this amount
          </p>
        </div>

        <div className="flex gap-2 pt-2">
          <ATMButton
            variant="outlined"
            onClick={onClose}
            extraClasses="flex-1"
            disabled={isChecking}
          >
            Cancel
          </ATMButton>
          <ATMButton
            onClick={handleSave}
            extraClasses="flex-1"
            disabled={isChecking}
          >
            {isChecking ? 'Checking...' : 'Save Configuration'}
          </ATMButton>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// AMOUNT SUMMARY CARD
// ============================================================
const AmountSummaryCard = ({
  items,
  customer,
  discount,
  onOpenDiscount,
}: AmountSummaryCardProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const { taxes, totalAmount } = calculatedAmounts(items);
  const numericTotal = Number(totalAmount) || 0;
  const discountAmount = calculateDiscountAmount(numericTotal, discount);
  const finalAmount = Math.max(0, numericTotal - discountAmount);

  return (
    <div className="flex flex-col gap-2 space-y-1">
      <div>
        <div>
          {taxes?.map((tax: any, index) => (
            <div key={index} className="flex gap-2 p-4 py-1">
              <div className="flex-1 text-xs truncate text-slate-500">
                {tax?.taxType && tax?.taxPercent ? (
                  <div>
                    {tax?.taxType} @ {tax?.taxPercent}%
                  </div>
                ) : null}
              </div>
              {tax?.taxAmount ? (
                <div className="min-w-[60px] text-sm text-slate-600 text-right">
                  {CURRENCY} {tax?.taxAmount.toFixed(2)}
                </div>
              ) : null}
            </div>
          ))}
        </div>

        <div className="flex gap-2 px-4 py-1 bg-yellow-100">
          <div className="flex-1 text-base font-medium">Sub Total</div>
          <div className="min-w-[60px] text-base font-medium text-slate-800 text-right">
            {CURRENCY} {numericTotal.toFixed(2)}
          </div>
        </div>

        {discount && discountAmount > 0 && (
          <div className="flex gap-2 px-4 py-1 bg-red-50">
            <div className="flex-1 text-sm font-medium text-red-700">
              Discount
              {discount.type === 'PERCENTAGE' ? ` (${discount.value}%)` : ''}
            </div>
            <div className="min-w-[60px] text-sm font-semibold text-red-600 text-right">
              - {CURRENCY} {discountAmount.toFixed(2)}
            </div>
          </div>
        )}

        {discount && discountAmount > 0 && (
          <div className="flex gap-2 px-4 py-1 bg-green-100">
            <div className="flex-1 text-base font-bold text-green-800">
              Final Amount
            </div>
            <div className="min-w-[60px] text-base font-bold text-green-800 text-right">
              {CURRENCY} {finalAmount.toFixed(2)}
            </div>
          </div>
        )}
      </div>

      <div className="px-4">
        <ATMButton
          onClick={() => dispatch(setIsOpenAddDialog(true))}
          children="Pay Now"
          disabled={!customer}
        />
      </div>
    </div>
  );
};

// ============================================================
// PROPS + DEBOUNCE HELPER
// ============================================================
type Props = {
  cartItems: any[];
  onRemove: (itemId: string) => void;
  onQuantityChange: (itemId: string, type: 'INCREMENT' | 'DECREMENT') => void;
  formikProps: FormikProps<any>;
  isDisabled: boolean;
};

const useDebounce = (callback: Function, delay: number) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  return useCallback(
    (...args: any[]) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );
};

// ============================================================
// MAIN COMPONENT
// ============================================================
const CartSummarySection = ({
  cartItems,
  onRemove,
  onQuantityChange,
  formikProps,
  isDisabled,
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const bookingCustomer = searchParams.get('customer');
  const [loading, setLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<SelectOption | null>(
    null,
  );

  const { values, setFieldValue } = formikProps;
  const [isOpenAddNotesDialog, setIsOpenAddNotesDialog] = useState(false);
  const [isOpenDiscountModal, setIsOpenDiscountModal] = useState(false);

  // ✅ Gift card local state — NO DB CALL
  const [giftCardModalItem, setGiftCardModalItem] = useState<any>(null);
  const [giftCardConfigs, setGiftCardConfigs] = useState<
    Record<string, GiftCardConfig>
  >({});

  const { userData, outlet, accessToken } = useSelector(
    (state: RootState) => state.auth,
  );

  const { isOpenDraftListDialog, isOpenCustomerDialog } = useSelector(
    (state: RootState) => state.cart,
  );
  const navigate = useNavigate();

  const { data: outletData, isLoading: outletDataLoading }: any = useFetchData(
    useGetOutletsQuery,
    {
      body: { isPaginationRequired: false },
    },
  );

  const filterBy: any = [{ fieldName: 'isActive', value: true }];
  if (bookingCustomer) {
    filterBy.push({
      fieldName: 'bookingCustomerId',
      value: bookingCustomer,
    });
  }

  const { data: customerData, isLoading: customerLoading } = useFetchData(
    useGetCustomersQuery,
    {
      body: {
        isPaginationRequired: false,
        filterBy: JSON.stringify(filterBy),
      },
    },
  );

  const [getDraftData] = useGetDraftByIdMutation();

  const { isOpenAddDialog, previewNewCustomerId } = useSelector(
    (state: RootState) => state?.cart,
  );
  const dispatch = useDispatch<AppDispatch>();

  const discount: DiscountValue = values?.discount || null;

  // ============================================================
  // ✅ STEP 1: Mark as Gift Card click — generate random code
  // (NO DB call — only local state)
  // ============================================================
  // const handleMarkAsGiftCardClick = (item: any) => {
  //   const randomCode = `GC-${Math.random()
  //     .toString(36)
  //     .substring(2, 8)
  //     .toUpperCase()}`;

  //   setGiftCardConfigs((prev) => ({
  //     ...prev,
  //     [item._id]: {
  //       couponCode: randomCode,
  //       physicalNumber: randomCode,
  //       amount: Number(item.sellingPrice) || 0,
  //       configured: false,
  //     },
  //   }));

  //   setGiftCardModalItem(item);
  // };

  const handleMarkAsGiftCardClick = (item: any) => {
  ShowConfirmation({
    type: 'INFO',
    title: 'Mark as Gift Card?',
    message: `Are you sure you want to mark "${item?.itemName}" as a gift card? A gift card coupon will be created at checkout with amount ${CURRENCY} ${Number(item?.sellingPrice || 0).toFixed(2)}.`,
    confirmationText: 'Yes, Continue',
    onConfirm: (closeDialog) => {
      // ✅ Original logic — random code + config + modal
      const randomCode = `GC-${Math.random()
        .toString(36)
        .substring(2, 8)
        .toUpperCase()}`;

      setGiftCardConfigs((prev) => ({
        ...prev,
        [item._id]: {
          couponCode: randomCode,
          physicalNumber: randomCode,
          amount: Number(item.sellingPrice) || 0,
          configured: false,
        },
      }));

      setGiftCardModalItem(item);

      closeDialog();
    },
  });
};

  // ============================================================
  // ✅ STEP 2: Modal apply — update config + Formik items (NO API)
  // ============================================================
const handleGiftCardApply = (
  item: any,
  updated: { physicalNumber: string; amount: number }
) => {
  // 1. Update local config
  setGiftCardConfigs((prev) => ({
    ...prev,
    [item._id]: {
      ...prev[item._id],
      physicalNumber: updated.physicalNumber,
      amount: updated.amount,
      configured: true,
    },
  }));

  // 2. Update Formik item
  const updatedItems = (values?.items || []).map((i: any) =>
    i._id === item._id
      ? {
          ...i,
          type: 'SERVICE_GIFTCARD',
          giftCardCode: updated.physicalNumber,
          giftCardAmount: updated.amount,
          // ✅ Original price preserve (revert ke liye)
          originalServicePrice: i.originalServicePrice ?? i.sellingPrice,
          sellingPrice: updated.amount,
          originalServiceId: i.originalServiceId || i._id,
        }
      : i
  );
  setFieldValue('items', updatedItems);

  setGiftCardModalItem(null);
  showToast(
    'success',
    'Gift card configured — coupon will be created on payment'
  );
};


  // ✅ X click → gift card remove, service restore
const handleRemoveGiftCard = (item: any) => {
  const currentItem = (values?.items || []).find(
    (i: any) => i._id === item._id
  );

  const restoredPrice =
    currentItem?.originalServicePrice ??
    currentItem?.sellingPrice ??
    0;

  // 1. Config delete
  setGiftCardConfigs((prev) => {
    const next = { ...prev };
    delete next[item._id];
    return next;
  });

  // 2. Formik item revert → SERVICE
  const updatedItems = (values?.items || []).map((i: any) =>
    i._id === item._id
      ? {
          ...i,
          type: 'SERVICE',
          giftCardCode: undefined,
          giftCardAmount: undefined,
          sellingPrice: restoredPrice,
          originalServiceId: undefined,
          originalServicePrice: undefined,
        }
      : i
  );
  setFieldValue('items', updatedItems);

  // 3. Modal close if open
  if (giftCardModalItem?._id === item._id) {
    setGiftCardModalItem(null);
  }

  showToast('success', 'Gift card removed — service restored');
};

  // ============================================================
  // ✅ STEP 3: Remove item — also cleanup config
  // ============================================================
  const handleRemoveItem = (itemId: string) => {
    // Remove from cart
    onRemove(itemId);

    // Cleanup local config
    setGiftCardConfigs((prev) => {
      const next = { ...prev };
      delete next[itemId];
      return next;
    });
  };

  const handleGetDraftData = (draftId: string) => {
    getDraftData(draftId).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          setFieldValue('customer', { _id: res?.data?.data?.customerId });
          setFieldValue(
            'items',
            res?.data?.data?.items?.map((item: any) => {
              return {
                _id: item?.itemId,
                itemName: item?.itemName,
                mrp: item?.mrp,
                sellingPrice: item?.sellingPrice,
                quantity: item?.quantity,
                type: item?.itemType,
                taxId: item?.taxId,
                taxPercent: item?.taxPercent,
                taxType: item?.taxType,
              };
            }),
          );
          setFieldValue('couponCode', res?.data?.data?.couponCode);
          setFieldValue('shippingCharges', res?.data?.data?.shippingCharges);
          setFieldValue(
            'amountReceived',
            res?.data?.data?.amountReceived?.map((el: any) => ({
              paymentModeId: { _id: el?.paymentModeId },
              amount: el?.amount?.toFixed(2),
            })),
          );
          setFieldValue('giftCardCode', res?.data?.data?.giftCardCode);
          setFieldValue('useLoyaltyPoints', res?.data?.data?.useLoyaltyPoints);
          setFieldValue('referralCode', res?.data?.data?.referralCode);
          setFieldValue('discount', res?.data?.data?.discount || null);
          showToast('success', res?.data?.message);
          dispatch(setIsOpenDraftListDialog(false));
        } else {
          showToast('error', res?.data?.message);
        }
      }
    });
  };

  useEffect(() => {
    if (previewNewCustomerId) {
      setFieldValue('customer', previewNewCustomerId);
      dispatch(setPreviewNewCustomerId(''));
    }
  }, [previewNewCustomerId]);

  // ✅ Sync discount + amountReceived + derived fields
  useEffect(() => {
    if (isOpenAddDialog) return;

    const subtotal = Number(calculatedAmounts(cartItems)?.totalAmount || 0);
    const discountAmt = calculateDiscountAmount(subtotal, discount);
    const finalAmount = Math.max(0, subtotal - discountAmt);

    setFieldValue('subtotal', subtotal.toFixed(2));
    setFieldValue('discountAmount', discountAmt.toFixed(2));
    setFieldValue('finalAmount', finalAmount.toFixed(2));

    const existingPayments = values?.amountReceived || [];

    if (existingPayments.length === 0) {
      setFieldValue('amountReceived', [
        { paymentModeId: '', amount: finalAmount.toFixed(2) },
      ]);
    } else if (existingPayments.length === 1) {
      setFieldValue('amountReceived', [
        { ...existingPayments[0], amount: finalAmount.toFixed(2) },
      ]);
    } else {
      const currentSum = existingPayments.reduce(
        (s: number, p: any) => s + Number(p?.amount || 0),
        0
      );
      if (Math.abs(currentSum - finalAmount) > 0.01) {
        const diff = finalAmount - currentSum;
        const last = existingPayments[existingPayments.length - 1];
        setFieldValue('amountReceived', [
          ...existingPayments.slice(0, -1),
          {
            ...last,
            amount: Math.max(0, Number(last.amount || 0) + diff).toFixed(2),
          },
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount, cartItems, isOpenAddDialog]);

  const fetchCustomerByBookingId = async (
    bookingCustomerId: string,
  ): Promise<SelectOption | null> => {
    const filterBy = JSON.stringify([
      {
        fieldName: 'bookingCustomerId',
        value: bookingCustomerId,
      },
    ]);

    try {
      const response = await fetch(
        `${BASE_URL}/customer/pagination?isPaginationRequired=false&filterBy=${filterBy}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        },
      );

      const result = await response.json();

      if (result?.data?.length > 0) {
        const customer: Customer = result.data[0];

        return {
          label: `${customer.customerName} - ${customer.phone} - ${customer.email}`,
          value: customer._id,
          data: customer,
        };
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    if (bookingCustomer) {
      fetchCustomerByBookingId(bookingCustomer).then((customer) => {
        if (customer) {
          setSelectedCustomer(customer);
          setFieldValue('customer', customer.data);
        }
      });
    }
  }, [bookingCustomer, setFieldValue]);

  const fetchOptions = async (inputValue: string): Promise<SelectOption[]> => {
    if (!inputValue?.trim()) return [];

    const query = inputValue.trim();
    let filterBy: any[] = [];

    const isEmail = query.includes('@');
    const isNumber = /^\d+$/.test(query);

    if (isEmail) {
      filterBy = [{ fieldName: 'email', value: query }];
    } else if (isNumber) {
      filterBy = [{ fieldName: 'phone', value: query }];
    } else {
      filterBy = [{ fieldName: 'customerName', value: query }];
    }

    try {
      const response = await fetch(
        `${BASE_URL}/customer/pagination?isPaginationRequired=false&filterBy=${encodeURIComponent(
          JSON.stringify(filterBy)
        )}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) return [];

      const data = await response.json();

      return (data?.data || []).map((item: any) => ({
        label: `${item.customerName || 'Unknown'} - ${item.phone || ''} - ${item.email || ''}`,
        value: item._id,
        data: item,
      }));
    } catch (error) {
      return [];
    }
  };

  const debouncedLoadOptions = useDebounce(
    async (inputValue: any, callback: (arg0: any[]) => void) => {
      setLoading(true);
      const options = await fetchOptions(inputValue);
      setLoading(false);
      callback(options);
    },
    1000,
  );

  const currentTotal = useMemo(
    () => Number(calculatedAmounts(cartItems)?.totalAmount || 0),
    [cartItems]
  );

  return (
    <div
      className={`flex flex-col w-full h-full gap-2 py-4 ${
        isDisabled ? 'pointer-events-none opacity-30' : ''
      }`}
    >
      <div className="flex flex-col gap-4 px-4">
        {/* Customer Search + Buttons */}
        <div className="flex items-center gap-4">
          <div className="flex-1">
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={debouncedLoadOptions}
              value={selectedCustomer}
              onChange={(selectedOption: SelectOption | null) => {
                setSelectedCustomer(selectedOption);
                setFieldValue(
                  'customer',
                  selectedOption ? selectedOption.data : null,
                );
              }}
              placeholder="Search..."
              isLoading={loading}
              isClearable
              isDisabled={isDisabled}
            />
          </div>

          <div>
            <ATMButton
              compact
              extraClasses={`p-2.5`}
              onClick={() => dispatch(setIsOpenTreatmentDialog(true))}
            >
              <IconPlaylistAdd size={14} />
            </ATMButton>
          </div>

          <div>
            <ATMButton
              compact
              extraClasses={`p-2.5`}
              onClick={() => dispatch(setIsOpenCustomerDialog(true))}
            >
              <IconPlus size={14} />
            </ATMButton>
          </div>
        </div>
      </div>

      {/* Items List */}
      <div className="flex flex-col flex-1 overflow-auto">
        <div className="flex gap-2 p-4 py-1 text-sm font-medium text-slate-800">
          <div className="flex-1 truncate">Item</div>
          <div className="min-w-[60px]">Qty</div>
          <div className="min-w-[100px] text-right">Price</div>
          <div className="min-w-[20px]"></div>
        </div>

        <div className="flex-1 overflow-auto">
          {cartItems?.map((item) => {
            const config = giftCardConfigs[item?._id];
            const isGiftCardItem = item?.type === 'SERVICE_GIFTCARD';

            return (
              <div
                key={item?._id}
                className={`flex items-center gap-2 p-4 py-2 text-slate-800 even:bg-gray-100 ${
                  isGiftCardItem ? 'bg-green-50/40' : ''
                }`}
              >
                <div className="flex-1 overflow-hidden text-xs">
                  <div className="w-full truncate font-medium">
                    {item?.itemName}
                    {item?.itemCode && !isGiftCardItem
                      ? ` - ${item.itemCode}`
                      : ''}
                  </div>

                 {/* ✅ SERVICE ke liye — mark/config link */}
{item?.type === 'SERVICE' && (
  <>
    {!config ? (
      <button
        type="button"
        className="text-[11px] text-primary cursor-pointer hover:underline mt-0.5 flex items-center gap-1"
        onClick={() => handleMarkAsGiftCardClick(item)}
      >
        🎁 Mark as Gift Card
      </button>
    ) : (
      <div
        className={`mt-1 flex items-center gap-1 text-[11px] rounded px-1.5 py-0.5 w-fit border ${
          config.configured
            ? 'bg-green-50 border-green-300 text-green-800'
            : 'bg-yellow-50 border-yellow-300 text-yellow-800'
        }`}
      >
        {/* ✅ Clickable — reopen modal */}
        <button
          type="button"
          className="flex items-center gap-1 cursor-pointer hover:opacity-80"
          onClick={() => setGiftCardModalItem(item)}
        >
          <span>🎁</span>
          <span className="font-mono font-bold">
            {config.physicalNumber || config.couponCode}
          </span>
          <span>
            • {CURRENCY} {config.amount.toFixed(2)}
          </span>
          {!config.configured && (
            <span className="text-[9px] italic ml-1">
              (tap to configure)
            </span>
          )}
        </button>

        {/* ✅ X button — remove gift card */}
        <button
          type="button"
          className="ml-1 rounded-full hover:bg-red-100 p-0.5 cursor-pointer text-red-500 hover:text-red-700"
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveGiftCard(item);
          }}
          title="Remove gift card"
        >
          <IconX size={11} />
        </button>
      </div>
    )}
  </>
)}

{/* ✅ SERVICE_GIFTCARD badge — clickable + X to remove */}
{isGiftCardItem && (
  <div className="mt-0.5 inline-flex items-center gap-1 text-[10px] bg-green-100 border border-green-300 text-green-800 rounded px-1.5 py-0.5 font-bold uppercase tracking-wide">
    {/* Clickable — reopen modal */}
    <button
      type="button"
      className="flex items-center gap-1 cursor-pointer hover:opacity-80"
      onClick={() => setGiftCardModalItem(item)}
    >
      🎁 Gift Card
      {item?.giftCardCode && (
        <span className="font-mono normal-case">
          • {item.giftCardCode}
        </span>
      )}
    </button>

    {/* X — remove → revert to SERVICE */}
    <button
      type="button"
      className="ml-1 rounded-full hover:bg-red-200 p-0.5 cursor-pointer text-red-600 hover:text-red-800"
      onClick={(e) => {
        e.stopPropagation();
        handleRemoveGiftCard(item);
      }}
      title="Remove gift card"
    >
      <IconX size={11} />
    </button>
  </div>
)}

                  <div className="font-medium text-pink-800 mt-0.5">
                    {item?.sellingPrice}
                  </div>
                </div>

                {/* Qty controls — gift card ke liye disabled */}
                {isGiftCardItem ? (
                  <div className="min-w-[60px] flex justify-center items-center bg-green-100 text-green-800 rounded p-0.5 text-xs font-semibold select-none">
                    1
                  </div>
                ) : (
                  <div className="min-w-[60px] flex bg-primary rounded items-center p-0.5">
                    <IconMinus
                      onClick={() =>
                        onQuantityChange(item?._id, 'DECREMENT')
                      }
                      size={14}
                      className="text-white cursor-pointer"
                    />
                    <div className="flex justify-center flex-1 text-xs text-white select-none">
                      {item?.quantity}
                    </div>
                    <IconPlus
                      onClick={() =>
                        onQuantityChange(item?._id, 'INCREMENT')
                      }
                      size={14}
                      className="text-white cursor-pointer"
                    />
                  </div>
                )}

                <div className="min-w-[100px] text-xs font-medium select-none text-right">
                  {(item?.sellingPrice * item?.quantity).toFixed(2)}
                </div>
                <div
                  className="min-w-[20px] text-right cursor-pointer"
                  onClick={() => handleRemoveItem(item?._id)}
                >
                  <IconTrash size={18} className="text-error" />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Amount Calculation */}
      <div className="border-t">
        {/* Notes + Add Discount */}
        <div className="flex justify-end gap-4 px-4 py-1">
          <div
            className="text-base font-medium cursor-pointer text-primary hover:underline"
            onClick={() => setIsOpenAddNotesDialog(true)}
          >
            Notes
          </div>

          <div
            className="text-base font-medium cursor-pointer text-primary hover:underline flex items-center gap-1"
            onClick={() => setIsOpenDiscountModal(true)}
          >
            <IconTag size={16} />
            {discount ? 'Edit Discount' : 'Add Discount'}
          </div>
        </div>

        {/* Totals row */}
        <div className="flex gap-2 p-4 py-1 text-sm font-medium text-slate-800">
          <div className="flex-1 truncate">Total {cartItems?.length}</div>
          <div className="min-w-[60px]">
            {cartItems?.reduce((sum, item) => {
              return sum + item?.quantity;
            }, 0)}
          </div>
          <div className="min-w-[100px] text-right">
            {cartItems
              ?.reduce((sum, item) => {
                return sum + item?.quantity * item?.sellingPrice;
              }, 0)
              .toFixed(2)}
          </div>
        </div>

        <AmountSummaryCard
          items={cartItems}
          customer={selectedCustomer}
          discount={discount}
          onOpenDiscount={() => setIsOpenDiscountModal(true)}
        />

        {/* Pay Now Modal */}
        {isOpenAddDialog && (
          <PaymentFormWrapper
            onClose={() => dispatch(setIsOpenAddDialog(false))}
            items={cartItems}
            customerId={values?.customer}
            formikProps={formikProps}
          />
        )}

        {/* Notes Modal */}
        {isOpenAddNotesDialog && (
          <AddNotes
            onClose={() => setIsOpenAddNotesDialog(false)}
            formType="ADD"
            formikProps={formikProps}
          />
        )}

        {/* ✅ Discount Modal */}
        {isOpenDiscountModal && (
          <DiscountModal
            onClose={() => setIsOpenDiscountModal(false)}
            onApply={(d) => setFieldValue('discount', d)}
            initial={discount}
            totalAmount={currentTotal}
          />
        )}

        {/* ✅ Gift Card Modal — local config only, NO API call */}
        {giftCardModalItem && giftCardConfigs[giftCardModalItem._id] && (
          <GiftCardModal
            item={giftCardModalItem}
            config={giftCardConfigs[giftCardModalItem._id]}
            onClose={() => setGiftCardModalItem(null)}
            onApply={(updated) =>
              handleGiftCardApply(giftCardModalItem, updated)
            }
          />
        )}

        {/* Draft List Modal */}
        {isOpenDraftListDialog && (
          <DraftList
            onClose={() => dispatch(setIsOpenDraftListDialog(false))}
            onEdit={(item) => {
              handleGetDraftData(item?._id);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CartSummarySection;